import { render, staticRenderFns } from "./reviewFeedback.vue?vue&type=template&id=6d330cfa&lang=html&"
import script from "./reviewFeedback.vue?vue&type=script&lang=ts&"
export * from "./reviewFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./reviewFeedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports